import qs from 'qs'

export default function serializeParams(params: unknown) {
  return qs.stringify(params, {
    arrayFormat: 'brackets',
    encodeValuesOnly: true,
    indices: false,
  })
}
